export const dateTimeFormats = {
  short: {
    month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  medium: {
    year: 'numeric', month: 'short', day: 'numeric'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
  },
  full: {
    year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
  }
};

export const messages = {
    "login.form.title": "로그인",
    "login.form.hint.user": "로그인",
    "login.form.hint.password": "암호",
    "login.form.checkbox.remember-me": "로그인 정보 저장",
    "login.form.button.sign-in": "로그인",
    "login.form.message.invalid-user-credentials": "로그인 또는 패스워드가 잘못되었습니다.",
    "login.form.message.user-required": "로그인 입력",
    "login.form.message.password-required": "비밀번호 입력",
    "login.form.button.forgot-password": "비밀번호를 잊으셨습니까?",
    "error.root-admin-login.title": "오류 403 – 금지됨",
    "error.root-admin-login.message": "읽기 전용 관리자로 로그인했습니다. 웹 복구 콘솔에 액세스하려면 고객 테넌트 사용자 또는 관리자로 로그인하십시오."
};
